export default __webpack_public_path__ + "static/media/cosmetic3.4cac43a9.JPG";